import React, { useEffect, useState } from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid, ResponsiveContainer } from 'recharts';
import axios from 'axios';
import { WEBSERVICE_IP } from '../../functions/roots/webserviceIP';

const CuadrantesPorSemana = () => {
  const [datos, setDatos] = useState([]);
  const usuarioId = sessionStorage.getItem('usuarioId');

  useEffect(() => {
    const fetchCuadrantes = async () => {
      try {
        const res = await axios.get(`${WEBSERVICE_IP}/reportes/grafica/cuadrantes-por-semana/${usuarioId}`);
        const { semanas, cuadrantes } = res.data;

        const formateado = semanas.map((semana, i) => ({
          semana,
          I: cuadrantes.I[i],
          II: cuadrantes.II[i],
          III: cuadrantes.III[i],
          IV: cuadrantes.IV[i]
        }));

        setDatos(formateado);
      } catch (error) {
        console.error('Error al obtener cuadrantes por semana:', error);
      }
    };

    if (usuarioId) fetchCuadrantes();
  }, [usuarioId]);

  return (
    <>
      {datos.length > 0 ? (
        <ResponsiveContainer width="100%" height={400}>
          <BarChart data={datos} margin={{ top: 20, right: 30, left: 0, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="semana" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="I" stackId="a" fill="#8884d8" />
            <Bar dataKey="II" stackId="a" fill="#82ca9d" />
            <Bar dataKey="III" stackId="a" fill="#ffc658" />
            <Bar dataKey="IV" stackId="a" fill="#ff7f7f" />
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <p className="text-center text-gray-500">Cargando datos...</p>
      )}
    </>
  );
};

export default CuadrantesPorSemana;
